import classes from './Loader.module.scss'

export const Loader = () => {
    return (
        <div className={classes['loader-wrapper']}>
            <span className={classes.loader}></span>
        </div>
    )
}
